import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('modules.common.DayPickerEditor', {
    dayLabel: 'day {num}',
    placeholder: 'Day',
});
